<template>
  <div class="imports-screen">
    <span class="imports-screen__title">Импорты</span>
    <div class="imports-screen__tabs">
      <span
      v-for="tab in getFilteredTabs"
      :key="tab.name"
      class="imports-screen__tab"
      :class="[
        isSuperAdmin && 'pointer',
        (isSuperAdmin && tab.name === selectedTab) && 'imports-screen__tab_selected'
      ]"
      @click="changeTab(tab)">
        {{ $t(tab.name) }}
      </span>
    </div>
    <Imports
    :imports-data="getImportsData"
    :selected-tab="selectedTab" />
  </div>
</template>

<script>
import Imports from './components/Imports.vue';

export default {
  name: 'ImportsScreen',
  components: {
    Imports,
  },
  data: () => ({
    tabs: [
      { name: 'My imports' },
      { name: 'All imports', admin: 'super' },
    ],
    selectedTab: 'My imports',
  }),
  created() {
    this.$store.commit('app/setAppIsLoading', true);

    this.$store.dispatch('imports/getImports')
      .finally(() => {
        this.$store.commit('app/setAppIsLoading', false);
      });
  },
  methods: {
    changeTab(tab) {
      if (tab.name === this.selectedTab) return;

      this.selectedTab = tab.name;

      if (tab.name === 'All imports' && this.isEmptyAllImportsData) {
        this.getAllImports();
      }
    },
    getAllImports() {
      // FUTURE сделать общий на весь APP Loader и ставить загрузку при любом экшене
      this.$store.commit('app/setAppIsLoading', true);
      this.$store.dispatch('imports/getAllImports', { reset: true })
        .finally(() => {
          this.$store.commit('app/setAppIsLoading', false);
        });
    },
  },
  computed: {
    getImportsData() {
      if (this.selectedTab === 'All imports') {
        return this.$store.getters['imports/getAllImportsData'];
      }
      return this.$store.getters['imports/getUserImportsData'];
    },
    isSuperAdmin() {
      return this.$store.getters['user/getIsSuperAdmin'];
    },
    getFilteredTabs() {
      if (this.isSuperAdmin || this.getIsRealisatorHead) return this.tabs;
      return this.tabs.filter((tab) => !tab.admin);
    },
    isEmptyAllImportsData() {
      return this.$store.getters['imports/getAllImportsData'].length === 0;
    },
    getIsRealisatorHead() {
      return this.$store.getters['user/getIsRealisatorHead'];
    },
  },
};
</script>

<style lang="scss" scoped>
.imports-screen {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 70px);
}

.imports-screen__title {
  font-size: 18px;
  font-weight: 600;
  margin: 0px 20px;
}

.imports-screen__tabs {
  padding-left: 20px;
  margin-top: 10px;
  @include between-elements {
    margin-right: 15px;
  }
}

.imports-screen__tab {
  color: rgba($primary-gray, 0.5);
  font-size: 13px;
  transition: 0.2s;
  cursor: pointer;
  position: relative;
  &_selected {
    color: $primary-blue;
    &:after {
      position: absolute;
      top: 20px;
      left: 0px;
      content: '';
      width: 100%;
      height: 1px;
      background: $primary-blue;
    }
  }
}

</style>
